module.exports = __webpack_public_path__ + "img/tcys.3f739bae.png";